export type AccessApprovalStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export class AccessApprovalRequestModel {
    access_approval_request_id: number;
    company_id: number;
    request_date: string;
    status: AccessApprovalStatus;
    reason?: string | null;
    decided_at?: Date | null;
    decided_by_user_id?: number | null;
    user_id: number;
    user_name?: string | null;
    /** Função do usuário (DRIVER/NURSE/PARAMEDIC/DOCTOR/...) — usado pra abrir o assistente de alocação já filtrado. */
    user_profile_type?: string | null;
    createdAt: Date;

    constructor(data: Partial<AccessApprovalRequestModel> = {}) {
        Object.assign(this, data);
    }
}

export type CheckCompanyAccessStatus = 'ALLOWED' | 'PENDING' | 'REJECTED';

export interface CheckCompanyAccessResult {
    ok: boolean;
    status: CheckCompanyAccessStatus;
    request_id?: number;
    reason?: string | null;
}
